import React from "react";
import Layout from "../components/Layout";
import { Link, useNavigate } from "react-router-dom";
import { setAlert } from "../actions/alert";
import { login } from "../actions/auth";
import { connect } from "react-redux";
import Alert from "../components/Alert";

const Login = ({ setAlert, login, auth: { isAuthenticated } }) => {
  const [formData, setFormData] = React.useState({
    email: "jazzelmehmood8@gmail.com",
    password: "Mpower1234",
  });
  const navigate = useNavigate();

  if (isAuthenticated) {
    return navigate("/dashboard");
  }

  const { email, password } = formData;
  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const submitHandler = async (e) => {
    e.preventDefault();

    if (email === "" || password === "") {
      setAlert("Please enter all fields", "danger");
    } else {
      const res = await login({ email, password });
      if (res) {
        setAlert("Success", "success");
      }
    }
  };

  return (
    <Layout>
      <div className="slider-area">
        <div className="single-slider hero-overly slider-height2 slider-bg2 d-flex align-items-center">
          <div className="container">
            <div className="row justify-content-center ">
              <div className="col-xxl-12">
                <div className="hero-caption hero-caption2">
                  <br />
                  <br />
                  <h2>Login</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="contact-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="contact-title">Enter your details</h2>
            </div>

            <div className="col-lg-8">
              <form
                className="form-contact contact_form"
                method="post"
                id="contactForm"
                onSubmit={submitHandler}
              >
                <Alert />
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        className="form-control valid"
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => onChange(e)}
                        placeholder="Email"
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group">
                      <input
                        className="form-control"
                        type="text"
                        value={password}
                        name="password"
                        onChange={(e) => onChange(e)}
                        placeholder="Enter Password"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group mt-3">
                  <button
                    type="submit"
                    className="button button-contactForm btn_1"
                  >
                    Login
                  </button>
                  <Link
                    to="/register"
                    style={{ marginLeft: 20, color: "white" }}
                  >
                    New here ? Register here.
                  </Link>
                </div>
              </form>
            </div>
            <div className="col-lg-3 offset-lg-1">
              <div className="media contact-info">
                <span className="contact-info__icon">
                  <i className="ti-home"></i>
                </span>
                <div className="media-body">
                  <h3>Sindh, Karachi, Pakistan</h3>
                  <p>Street abcs</p>
                </div>
              </div>
              <div className="media contact-info">
                <span className="contact-info__icon">
                  <i className="ti-tablet"></i>
                </span>
                <div className="media-body">
                  <h3>+01 (23) 456 789</h3>
                  <p>Mon to Fri 9am to 6pm</p>
                </div>
              </div>
              <div className="media contact-info">
                <span className="contact-info__icon">
                  <i className="ti-email"></i>
                </span>
                <div className="media-body">
                  <h3>atomos@atomos.com</h3>
                  <p>Send us your query anytime!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { setAlert, login })(Login);
